"use client";
import { motion } from "framer-motion";
import { Box } from "@mantine/core";

interface PageShellProps {
  children: React.ReactNode;
  padding?: string;
}

// The one enter fade per navigation. Nothing inside a page should fade or
// pop in on mount on top of this, or the page reads as loading twice.
const PageShell = ({ children, padding = "lg" }: PageShellProps) => {
  return (
    <motion.div
      // @ts-ignore
      className="PageShell"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      // minWidth 0 lets the page shrink inside AppShell's nowrap Group so
      // wide tables scroll in their own container instead of the page
      style={{ height: "100%", width: "100%", flexGrow: 1, minWidth: 0 }}
    >
      <Box flex={1} p={padding} h="100%">
        {children}
      </Box>
    </motion.div>
  );
};

export default PageShell;
